import { Box } from "@mui/material"
import { ReactElement } from "react"

export function Separator(): ReactElement {
  return (
    <Box
      sx={{
        borderTop: "1px solid #EEF2F6",
        height: "1px",
      }}
    />
  )
}
